import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";

const MobileView = props => {
    const { t } = useTranslation();
    return (
        <div>
            <h1>Download im Store</h1>
            {t('mobile.download')}<br />
            <a href='https://apps.apple.com/om/app/braille-%C3%BCbungen/id1509922958'>
                <img className='download_logo' src='app_store_logo.png' alt='App Store'></img>
            </a>
            <a href='https://play.google.com/store/apps/details?id=com.braille_uebungen&hl=gsw&gl=US'>
                <img className='download_logo' src='google_play_logo.png' alt='Google Play Store'></img>
            </a><br />
            <a href={`mailto:info@braille.training`}>{t('contact.send_mail')}</a>
        </div>
    )
}
export default MobileView